const money = (v) =>
  Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });

function toNumberOrNull(value) {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function badgeClass(abonadoPor) {
  if (abonadoPor === 'CAJA CHICA') return 'bg-yellow-100 text-yellow-800 border-yellow-200';
  if (abonadoPor === 'CUENTA CORRIENTE') return 'bg-red-100 text-red-800 border-red-200';
  if (abonadoPor === 'TODOS') return 'bg-gray-100 text-gray-800 border-gray-200';
  return 'bg-gray-100 text-gray-800 border-gray-200';
}

function LoadingTable() {
  const headers = ['DIA', 'DESCRIPCION', 'CUOTA', 'MONTO', 'SALDO', 'ABONADO POR'];

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500 bg-gray-50 border-b border-gray-200">
              {headers.map((h) => (
                <th key={h} className={h === 'DESCRIPCION' ? 'py-6 px-3 text-left' : 'py-6 px-3 text-center'}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {[...Array(6)].map((_, index) => (
              <tr key={index} className="animate-pulse">
                {headers.map((h) => (
                  <td key={h} className={h === 'DESCRIPCION' ? 'px-6 py-4' : 'px-6 py-4 text-center'}>
                    <div className={`h-4 ${h === 'DESCRIPCION' ? 'w-72' : 'w-24'} bg-gray-300 rounded ${h === 'DESCRIPCION' ? '' : 'mx-auto'}`}></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
      </table>
    </div>
  );
}

export default function FinanzasTable({ pagos, isLoading = false }) {
  const rows = Array.isArray(pagos) ? pagos : [];

  if (isLoading) return <LoadingTable />;

  if (rows.length === 0) {
    return (
      <div className="rounded-3xl border border-gray-100 bg-white p-8 text-center shadow-sm">
        <p className="text-gray-500 text-lg">No se encontraron datos con los filtros seleccionados</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500 bg-gray-50 border-b border-gray-200">
              <th className="py-6 px-3 text-center">DIA</th>
              <th className="py-6 px-6 text-left">DESCRIPCION</th>
              <th className="py-6 px-3 text-center">CUOTA</th>
              <th className="py-6 px-3 text-center">MONTO</th>
              <th className="py-6 px-3 text-center">SALDO</th>
              <th className="py-6 px-3 text-center">ABONADO POR</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {rows.map((row, index) => {
              const isSaldoInicio = row?.descripcion === 'SALDO DE INICIO DE MES' || row?.tipo === 'saldo_inicio';
              const monto = toNumberOrNull(row?.monto);
              const saldo = toNumberOrNull(row?.saldo);
              const abonadoPor = row?.abonado_por || '-';

              return (
                <tr
                  key={row?.id || `${row?.dia || 'na'}-${index}`}
                  className={
                    isSaldoInicio
                      ? 'bg-gray-50 font-semibold'
                      : 'transition hover:bg-rose-50/40 odd:bg-white even:bg-gray-50/40'
                  }
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 text-center">
                    {row?.dia || '-'}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900 whitespace-normal break-words max-w-xs sm:max-w-sm md:max-w-md">
                    {row?.descripcion || '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                    {row?.cuota ?? '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-center">
                    {monto === null ? '-' : (
                      <span className={monto < 0 ? 'text-red-700' : 'text-emerald-700'}>
                        {money(monto)}
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900 text-center">
                    {saldo === null ? '-' : money(saldo)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center">
                    <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full border ${badgeClass(abonadoPor)}`}>
                      {abonadoPor}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
      </table>
    </div>
  );
}
